import WarningNoteContainer from './WarningNoteContainer';

export default WarningNoteContainer;
